import {
    ADD_COMMENT,
    ADD_COMMENT_FAILURE,
    ADD_COMMENT_SUCCESS,
    DELETE_COMMENT_SUCCESS,
    EDIT_COMMENT,
    EDIT_COMMENT_SUCCESS,
    GET_COMMENT_COUNT_SUCCESS,
    GET_COMMENTS,
    GET_COMMENTS_FAILURE,
    GET_COMMENTS_SUCCESS,
    LIKE_COMMENT_SUCCESS,
    ON_CHANGE,
    ONCHANGE_UPDATE_COMMENT,
    SET_UPDATING_COMMENT,
    SHOW_NOTIFICATION,
    UNLIKE_COMMENT_SUCCESS,
    UPDATE_COMMENT_CHANGE,
    UPDATE_COMMENT_COUNT
} from "../constants";

import CONFIG from './../config'

const initialState = {
    error: false,
    comments: [],
    offset: 0,
    recentlyCommented: {},
    allCommentsLoaded: false,
    loadingGetComment: false,
    errorGetComment: false,
    latestComments: [],
    commentText: "",
    editComment: {},
    updatingComment: false,
    notification: {
        message: '',
        show: false
    },
    totalComments: 0
};

function getUnique(comments) {
    // return [...new Set(comments.map( (x) => x))]
    const result = [];
    const map = new Map();
    for (const item of comments) {
        if (!map.has(item.id)) {
            map.set(item.id, true);    // set any value to Map
            result.push(item);
        }
    }
    return result;
}

/**
 *
 * @param {Array} comments
 * @param {Object} payload
 */
function getUpdatedComment(comments, payload) {
    const {commentId, userId} = payload;
    let _comments = [];
    comments.forEach((comment) => {
        if (comment.id === commentId) {
            let likes = [];
            comment.likes.users.map((user) => {
                if (user.userId === userId) {

                } else {
                    likes.push(user)
                }
            });
            comment.likes = {
                users: likes,
                likesCount: likes ? likes.length : 0
            };
            _comments.push(comment);
        } else {
            _comments.push(comment);
        }
    });
    return _comments;
}

/**
 *
 * @param {String} comments
 * @param {String} payload
 * Adds likes object to comment
 */
function updateLikeComment(comments, payload, commentId) {
    if (!payload) {
        return comments;
    }

    comments.forEach((comment) => {
        if (comment.id === commentId) {
            if (!comment.likes) {
                comment.likes = {
                    users: [],
                    likesCount: 0
                }
            }
            comment.likes.users.push(payload);
            comment.likes.likesCount = comment.likes.likesCount + 1;
        }
    });
    return comments;
}

/**
 *
 * @param {*} comments
 * @param {*} commentId
 */
function getCommentAfterDelete(comments, commentId) {
    return comments.filter((comment) => {
        return comment.id !== commentId
    });
}


/**
 *
 * @param {*} comments
 * @param {*} comment
 */
function getUpdatedCommentsAfterUpdate(comments, comment) {
    for (var i = 0; i < comments.length; i++) {
        if (comments[i].id === comment.id) {
            comments[i] = comment;
            break;
        }
    }
    return comments;
}


function commentsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_COMMENTS:
            return {
                ...state,
                loadingGetComment: true,
                errorGetComment: false
            }

        case GET_COMMENTS_SUCCESS:
            let comments = state.comments.concat(action.payload.data.comments);
            comments = getUnique(comments);
            // if(state.offset != 0 &&){

            // }
            let offset = state.offset + CONFIG.COMMENT_OFFSET;
            let allCommentsLoaded = false;
            if (!action.payload || !action.payload.data || !action.payload.data.comments || action.payload.data.comments.length < CONFIG.COMMENT_OFFSET) {
                allCommentsLoaded = true;
            }
            return {
                ...state,
                comments,
                offset,
                allCommentsLoaded,
                loadingGetComment: false,
                errorGetComment: false

            }

        case GET_COMMENTS_FAILURE:
            return {
                ...state,
                loadingGetComment: false,
                errorGetComment: true
            }

        case ADD_COMMENT:
            return {
                ...state
            }

        case ADD_COMMENT_SUCCESS:
            action.payload.comment.recent = true;
            const _comments = state.comments.concat(action.payload.comment);
            let totalComments = state.totalComments + 1;
            if (Number.isNaN(totalComments)) {
                totalComments = 0;
            }
            return {
                ...state,
                comments: _comments,
                commentText: "",
                totalComments
            }

        case ADD_COMMENT_FAILURE:
            return {
                ...state
            }

        case ON_CHANGE:
            return {
                ...state,
                commentText: action.payload.commentText
            }

        case LIKE_COMMENT_SUCCESS:
            const {response, commentId} = action.payload;
            return {
                ...state,
                comments: response.statues === 204 ? satte.comments : updateLikeComment(state.comments, response.data, commentId)
            }

        case UNLIKE_COMMENT_SUCCESS:
            return {
                ...state,
                comments: getUpdatedComment(state.comments, action.payload)
            }

        case DELETE_COMMENT_SUCCESS:
            const __total = state.totalComments - 1
            if (Number.isNaN(__total)) {
                __total = 0;
            }
            return {
                ...state,
                comments: getCommentAfterDelete(state.comments, action.payload),
                totalComments: __total,
                offset: state.offset - 1
            }

        case UPDATE_COMMENT_CHANGE:
            return {
                ...state,
                editComment: Object.assign({}, action.payload)
            }

        case ONCHANGE_UPDATE_COMMENT:
            const _comment = state.editComment;
            _comment.commentText = action.payload;
            return {
                ...state,
                editComment: _comment
            }

        case EDIT_COMMENT:
            return {
                ...state
            }

        case EDIT_COMMENT_SUCCESS:
            const __comments = getUpdatedCommentsAfterUpdate(state.comments, action.body);
            return {
                ...state,
                __comments,
                editComment: {
                    commentText: ""
                },
                updatingComment: false
            }

        case SET_UPDATING_COMMENT:
            return {
                ...state,
                updatingComment: action.payload
            }

        case SHOW_NOTIFICATION:
            return {
                ...state,
                notification: {
                    show: action.payload.flag,
                    message: action.payload.flag ? action.payload.flag : '',
                    error: false
                }
            }

        case GET_COMMENT_COUNT_SUCCESS:
            const _total = action.payload.data.cmmentsCount ? action.payload.data.cmmentsCount : action.payload.data.commentsCount;
            if (Number.isNaN(_total)) {
                _total = 0;
            }
            return {
                ...state,
                totalComments: _total
            }

        case UPDATE_COMMENT_COUNT:
            return {
                ...state,
                offset: action.payload
            }

        default:
            return state;
    }
}

export default commentsReducer;
